import { useCallback } from 'react';
import toast from 'react-simple-toasts';

export type ToastMessages = {
    pending: string;
    success: string;
    fail: string;
};

export const usePromiseToast = <T,>(resolveSuccess?: (result: T) => boolean) => {
    const handler = useCallback((promise: Promise<T>, messages: ToastMessages) => {
        const pendingToast = toast(messages.pending, { theme: 'info', duration: 0, clickClosable: true, loading: true, className: 'df-mosaic' });
        let succeeded = false;
        promise
            .then((result) => {
                succeeded = resolveSuccess ? !!resolveSuccess(result) : true;
            })
            .catch(() => {
                succeeded = false;
            })
            .finally(() => {
                pendingToast.update({ theme: succeeded ? 'success' : 'warning', message: succeeded ? messages.success : messages.fail, duration: 3000, loading: false });
            });
    }, [resolveSuccess]);

    return handler;
};

export default usePromiseToast;
